module.exports = __webpack_public_path__ + "../resources/images/illustration_moon_error-25cac9855d612432a5c17a691fa89a3f.svg";